/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
// @ts-ignore
import html2pdf from 'html2pdf.js';

export type DownloadParams = {
  filename: string;
  scale?: number;
  slides: HTMLElement[];
  width?: number;
  height?: number;
  orientation?: 'landscape' | 'portrait';
  onSuccess?: (pdf: any) => void;
  onError?: (error: Error) => void;
};

// Simple function to ensure bullet points are visible in PDF without modifying existing styles
function ensureBulletPointsVisible(slide: HTMLElement): void {
  // Find all lists in the slide and ensure they have proper list-style
  const lists = slide.querySelectorAll('ul, ol');
  lists.forEach((list: any) => {
    // Only add list-style if it's not already set
    if (!list.style.listStyleType) {
      list.style.listStyleType = list.tagName === 'UL' ? 'disc' : 'decimal';
    }
    // Ensure list items are displayed as list items
    const listItems = list.querySelectorAll('li');
    listItems.forEach((li: any) => {
      if (!li.style.display || li.style.display === 'block') {
        li.style.display = 'list-item';
      }
    });
  });
}

export function download({
  filename,
  slides,
  scale = 1,
  width = 1256,
  height = 696,
  onSuccess,
  onError,
}: DownloadParams): Promise<void> {
  return new Promise((resolve, reject) => {
    // Dar tiempo al navegador para renderizar
    setTimeout(async () => {
      // Create container with all slides and proper page breaks
      const container = document.createElement('div');
      container.id = 'html-to-pdf-container';

      try {
        const orientation = width > height ? 'landscape' : 'portrait';

        const options = {
          jsPDF: {
            unit: 'px',
            format: [width, height],
            orientation: orientation,
            // Enable multi-page support'
            compress: true, // Enable PDF compression
            floatPrecision: 2,
            putOnlyUsedFonts: true,
          },
          html2canvas: {
            scale,
            useCORS: true,
            letterRendering: true,
            allowTaint: false,
            logging: false,
            // Optimize image quality vs file size
            imageTimeout: 0,
            removeContainer: true,
            // Process cloned document to ensure bullet points are visible
            onclone: (clonedDoc: Document) => {
              // Find the container in the cloned document
              const clonedContainer = clonedDoc.getElementById(
                'html-to-pdf-container',
              );
              if (clonedContainer) {
                // Simply ensure bullet points are visible in the cloned document
                ensureBulletPointsVisible(clonedContainer as HTMLElement);
              }
            },
            // // Filter out heavy elements
            // ignoreElements: (element: any) => {
            //   // Skip elements that are too heavy for PDF
            //   if (element.tagName === 'SCRIPT') return true;
            //   if (element.tagName === 'STYLE' && element.textContent?.includes('animation')) return true;
            //   if (element.classList?.contains('MuiDataGrid-virtualScroller')) return true;
            //   // Don't ignore markdown-editor - we need its content!
            //   // if (element.classList?.contains('markdown-editor')) return true;
            //   return false;
            // },
          },
        };

        // Clone slides with proper page break styling
        slides.forEach(slide => {
          const slideClone = slide.cloneNode(true) as HTMLElement;

          // Simply ensure bullet points are visible without modifying existing styles
          ensureBulletPointsVisible(slideClone);

          container.appendChild(slideClone);
        });

        // // Add container to DOM
        // document.body.appendChild(container);

        // console.log('Container created with all slides:', container);
        // console.log('Total slides:', slides.length);

        // Use html2pdf with optimized settings for multi-page
        const worker = html2pdf();
        const pdfBlob = await worker
          .from(container)
          .set(options)
          .outputPdf('blob');

        // Clean up
        if (container.parentNode) {
          document.body.removeChild(container);
        }

        const file = new File([pdfBlob], `${filename}.pdf`, {
          type: 'application/pdf',
        });

        const downloadUrl = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `${filename}.pdf`;
        link.click();
        URL.revokeObjectURL(downloadUrl);

        onSuccess?.(file);
        resolve();
      } catch (err) {
        // Clean up on error
        if (container.parentNode) {
          document.body.removeChild(container);
        }
        onError?.(err as Error);
        reject(err);
      }
    }, 100);
  });
}
